import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { lastValueFrom } from 'rxjs';
import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { UtilityService } from "./utility.service";
import { HaulRate } from "../objects/HaulRate.class";

@Injectable()
export class DeliveryRateService{
    
    constructor( private _http: HttpClient,private userSrv:UserService, private utilService:UtilityService ){}

    public getHaulRate(lat:number, lng:number):Promise<HaulRate[]>{
        let username = this.userSrv.getUserName();
        let token = this.userSrv.getUserToken();
        return new Promise((resolve,reject)=>{
            const body = new HttpParams()
            let result = lastValueFrom(this.postRequest(this.utilService.getBaseUrl()+'DeliveryRate/getHaulRate?latitude='+lat+'&longitude='+lng + '&username='+username+"&token="+token,body ));
                result.then((data:any)=>{
                    console.log(data);
                    let array:HaulRate[]=[];
                    data.forEach((item:any)=>{
                        array.push(new HaulRate(item))
                    })
                    resolve(array)
                }).catch((error)=>{
                    console.log(error);
                    reject(error);
                })
        });
    }

    private postRequest(url:string, body:HttpParams){
        return this._http.post(url,body.toString(),{headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')})
    }
}